module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasError) ? _c('PageError') : _c('div', [_c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [_c('PageOrganization', _vm._b({
    attrs: {
      "border-top": true
    }
  }, 'PageOrganization', _vm.pageBinds, false), [_c('span', {
    attrs: {
      "slot": _vm.slotNames.TOP
    },
    slot: _vm.slotNames.TOP
  }), _c('TabsMenu', {
    attrs: {
      "items": _vm.menu
    }
  }), _c('TransitionFade', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), (_vm.hasPrograms) ? _c('ExtraLayout', {
    attrs: {
      "bg": "gray"
    }
  }, [_c('ProgramsList', {
    attrs: {
      "usePadding": true,
      "items": _vm.programsPrepared,
      "doubler": false
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.bestProgramsTitle))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a76c2a82","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/component.vue
// module id = c9f1582d032422458ae6
// module chunks = 1